/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTabPointsRequest
 */
export interface UpdateTabPointsRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateTabPointsRequest
     */
    tabPoints: number;
}

/**
 * Check if a given object implements the UpdateTabPointsRequest interface.
 */
export function instanceOfUpdateTabPointsRequest(value: object): value is UpdateTabPointsRequest {
    if (!('tabPoints' in value) || value['tabPoints'] === undefined) return false;
    return true;
}

export function UpdateTabPointsRequestFromJSON(json: any): UpdateTabPointsRequest {
    return UpdateTabPointsRequestFromJSONTyped(json, false);
}

export function UpdateTabPointsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTabPointsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tabPoints': json['tabPoints'],
    };
}

export function UpdateTabPointsRequestToJSON(json: any): UpdateTabPointsRequest {
    return UpdateTabPointsRequestToJSONTyped(json, false);
}

export function UpdateTabPointsRequestToJSONTyped(value?: UpdateTabPointsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tabPoints': value['tabPoints'],
    };
}

